import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { formatDate, isPlatformBrowser } from '@angular/common';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';

export interface ValueCard {
  description: string;
  name: string;
  img: string;
}
@Component({
  selector: 'app-new-about',
  templateUrl: './new-about.component.html',
  styleUrls: ['./new-about.component.scss'],
  standalone: false,
})
export class NewAboutComponent implements OnInit {
  valueCards: ValueCard[] = [
    {
      img: '../../assets/images/innovation.svg ',
      name: 'Innovation',
      description: `We believe that innovation is the only way forward. We're constantly thinking about how to improve our products and services, so that you can always have the best experience.`,
    },
    {
      img: '../../assets/images/simplicity.svg ',
      name: 'Simplicity',
      description: `We strive for simplicity above all else. We want our products to be easy to understand, easy to use, and easy on the environment. `,
    },
    {
      img: '../../assets/images/userfocus.svg ',
      name: 'User focus',
      description: `We believe in putting our customers first. We believe in making our products and services easy to use, even if that means we have to do things differently from other companies.`,
    },
    {
      img: '../../assets/images/compassion.svg ',
      name: 'Compassion',
      description: `We believe that the world is a better place when we treat each other with dignity and respect.`,
    },
    {
      img: '../../assets/images/trust.svg ',
      name: 'Trust',
      description: `We are committed to the highest levels of integrity and honesty in all our business dealings.`,
    },
    {
      img: '../../assets/images/respect.svg ',
      name: 'Respect',
      description: `We respect our customers by listening carefully to their feedback, taking their ideas seriously, and investing resources in improving the quality of our products based on those suggestions.`,
    },
  ];

  array = [
    {
      imgUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/Innovation.png',
      heading: 'Innovation',
      description:
        "Innovation is the only way forward. We're constantly thinking about how to improve our products and services, so that you can always have the best experience.",
    },
    {
      imgUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/Simple.png',
      heading: 'Simplicity',
      description:
        'We strive for simplicity above all else. We want our products to be easy to understand, easy to use, & easy on the environment.',
    },
    {
      imgUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/focus.png',
      heading: 'User focus',
      description:
        'We believe in putting our customers first, & making our products and services easy to use, even if that means we have to do  things differently from other companies.',
    },
    {
      imgUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/compassion.png',
      heading: 'Compassion',
      description:
        'We believe that the world is a better place when we treat each other with dignity and respect.',
    },
    {
      imgUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/trust.png',
      heading: 'Trust',
      description:
        'We are committed to the highest levels of integrity and honesty in all our business dealings.',
    },
    {
      imgUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/Respect.png',
      heading: 'Respect',
      description:
        'We respect our customers by listening carefully to their feedback,  taking their ideas seriously, and investing resources based on those suggestions.',
    },
  ];

  teamMembers: any[] = [
    {
      id: 1,
      position: 'Founder & CEO',
      name: 'Abhivendra Singh Parihar',
      linkedInUrl: 'https://www.linkedin.com/in/abhivendrasingh/',
      xUrl: 'https://x.com/abhivendra',
      instaUrl: 'https://www.instagram.com/abhivendra.singh/',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/abhi-image.jpg',
    },
    {
      id: 2,
      position: 'Co-Founder & COO',
      name: 'Dattathreya Kanigiri',
      linkedInUrl:
        'https://www.linkedin.com/in/dattathreya-kanigiri-439a571a5/',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/dattu-image.jpg',
    },
    {
      id: 3,
      position: 'Co-Founder & CFO',
      name: 'Chanchal Gupta',
      linkedInUrl: '',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/chancal-image.jpg',
    },
    {
      id: 4,
      position: 'Co-Founder',
      name: 'Prakash Jha',
      linkedInUrl: '',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/prakas-image.jpg',
    },
    {
      id: 5,
      position: 'UI & UX Designer',
      name: 'Smith Bhojak',
      linkedInUrl: 'https://www.linkedin.com/in/bhojaksmith/',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/image-male.png',
    },
    {
      id: 6,
      position: 'Full-Stack Developer',
      name: 'Ravi Kiran',
      linkedInUrl:
        'https://www.linkedin.com/in/vavilapalli-ravi-kiran-79aa69231/',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/ravi-kiran-image.jpg',
    },
    {
      id: 6,
      position: 'App Developer',
      name: 'Aditya',
      linkedInUrl: 'https://www.linkedin.com/in/aditya-kumar-99995b258/',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/image-male.png',
    },
    {
      id: 6,
      position: 'Full-Stack Developer',
      name: 'Vivek Gobburu',
      linkedInUrl: 'https://www.linkedin.com/in/vivek-gobburu-638514228/',
      xUrl: '',
      instaUrl: '',
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/image-male.png',
    },
  ];

  timelineData: any = [];
  colorsArray = ['rgba(255, 255, 255, 1)', 'rgba(0, 102, 253, 1)'];
  constructor(
    private title: Title,
    private meta: Meta,
    private deviceDetectorService: DeviceDetectorService,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.title.setTitle(
      'Experience the Future of Education with Inforida | About Us'
    );
    this.meta.addTags([
      {
        name: 'title',
        content: 'Experience the Future of Education with Inforida | About Us',
      },
      {
        name: 'description',
        content: `${formatDate(
          Date.now(),
          'EEE, dd MMMM YYYY',
          'en-US'
        )} : Discover the story of Inforida, a leading provider of innovative digital solutions for schools. Learn about our mission and commitment to education excellence.`,
      },
      {
        name: 'keywords',
        content:
          'smart school, school erp, education technology, school performance, schools of future, best school erp, school admission software, fees collection software, school fees, school attendance, school tools, school management, Edtech solutions, Classroom technology, Digital learning tools, School management software, Student information systems, Learning management systems, Educational apps, Academic technology, Online learning platforms, E- learning solutions, Education technology, Classroom management solutions, Customizable digital tools, School administration software, Teacher productivity tools, Parent communication platform, Student performance analytics',
      },
    ]);
    this.timelineData = [
      {
        title: 'Mar 2022',
        content: `
          <p>Started with a vision</p>
          <ul>
            <li>To simplify and transform school management systems</li>
            <li>Created the first prototype of our innovative platform</li>
            <li>Developed core features for school administration</li>
          </ul>
        `,
      },
      {
        title: 'Aug 2022',
        content: `
          <p>Launched Nucleus V1</p>
          <ul>
            <li>Released our first smart school management system</li>
            <li>Introduced digital solutions for administration and academics</li>
            <li>Provided automation tools to streamline daily operations</li>
          </ul>
        `,
      },
      {
        title: 'Feb 2023',
        content: `
          <p>First User Milestone</p>
          <ul>
            <li>Welcomed MKD School in Uttar Pradesh as our first partner</li>
            <li>Successfully implemented complete digital management suite</li>
            <li>Established proof of concept in real-world conditions</li>
          </ul>
        `,
      },
      {
        title: 'May 2023',
        content: `
          <p>Reached 10+ Schools</p>
          <ul>
            <li>Expanded to serve more than 10 educational institutions</li>
            <li>Increased adoption across diverse school environments</li>
            <li>Validated our platform through multiple implementation successes</li>
          </ul>
        `,
      },
      {
        title: 'Mar 2024',
        content: `
          <p>Expanded to 50+ Schools</p>
          <ul>
            <li>Achieved significant growth with 50+ institutions onboarded</li>
            <li>Enhanced platform with user-requested improvements</li>
            <li>Optimized automation processes based on real-world feedback</li>
          </ul>
        `,
      },
      {
        title: 'Jul 2024',
        content: `
          <p>Launched Nucleus V2</p>
          <ul>
            <li>Introduced advanced AI capabilities and analytics</li>
            <li>Redesigned interface for improved user experience</li>
            <li>Added powerful tools for comprehensive school management</li>
          </ul>
        `,
      },
      {
        title: 'Dec 2024',
        content: `
          <p>Reached 100+ Schools</p>
          <ul>
            <li>Expanded our community to over 100 educational institutions</li>
            <li>Strengthened platform reliability for larger user base</li>
            <li>Enhanced scalability to support growing school networks</li>
          </ul>
        `,
      },
      {
        title: 'Jan 2025',
        content: `
          <p>Launched Good Morning</p>
          <ul>
            <li>Introduced AI-powered facial recognition attendance system</li>
            <li>Eliminated manual attendance tracking and associated errors</li>
            <li>Streamlined daily attendance processes for schools</li>
          </ul>
        `,
      },
      {
        title: 'Feb 2025',
        content: `
          <p>Launched QuickEnroll AI</p>
          <ul>
            <li>Created comprehensive admission management system with website builder</li>
            <li>Simplified student enrollment processes for administrators</li>
            <li>Enabled schools to establish professional digital presence</li>
          </ul>
        `,
      },
      {
        title: 'Mar 2025',
        content: `
          <p>Launched Nucleus V3</p>
          <ul>
            <li>Released our most advanced school ERP system to date</li>
            <li>Integrated AI-driven analytics for data-informed decision making</li>
            <li>Enhanced automation capabilities with third-party integrations</li>
          </ul>`,
      },
    ];
  }

  isMobile(): boolean {
    // return true;
    return this.deviceDetectorService.isMobile();
    // return (
    //   window.matchMedia(`(min-width: 200px)`).matches &&
    //   window.matchMedia(`(max-width: 800px)`).matches
    // );
  }
  getValueCols() {
    return this.isMobile() ? 1 : 3;
  }

  getValueHeight() {
    return this.isMobile() ? 1 : 2;
  }

  goToWhatsApp() {
    const url = 'https://whatsapp.com/channel/0029VaC08cb4yltJFDge9U0j';
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  goToPage() {}
}
